import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReadOnlyFormHelper {

  /**
   * Recursively disables a FormGroup, FormArray, or FormControl without firing event noise.
   */
  public disableForm(control: AbstractControl | null | undefined, options: { emitEvent?: boolean } = { emitEvent: false }): void {
    if (!control) return;

    if (control.enabled) {
      control.disable({ emitEvent: options.emitEvent ?? false });
    }

    if (control instanceof FormGroup) {
      Object.keys(control.controls).forEach(key => {
        this.disableForm(control.controls[key], options);
      });
    } else if (control instanceof FormArray) {
      control.controls.forEach(c => {
        this.disableForm(c, options);
      });
    }
  }

  /**
   * Recursively enables a FormGroup, FormArray, or FormControl.
   */
  public enableForm(control: AbstractControl | null | undefined, options: { emitEvent?: boolean } = { emitEvent: false }): void {
    if (!control) return;

    if (control.disabled) {
      control.enable({ emitEvent: options.emitEvent ?? false });
    }

    if (control instanceof FormGroup) {
      Object.keys(control.controls).forEach(key => {
        this.enableForm(control.controls[key], options);
      });
    } else if (control instanceof FormArray) {
      control.controls.forEach(c => {
        this.enableForm(c, options);
      });
    }
  }

  /**
   * Watches a reactive form and keeps it disabled whenever mutations or patches occur.
   */
  public attachAutoDisable(form: FormGroup, isReadOnlyFn: () => boolean): Subscription {
    if (isReadOnlyFn()) {
      this.disableForm(form);
    }

    return form.valueChanges.subscribe(() => {
      if (isReadOnlyFn() && form.enabled) {
        this.disableForm(form);
      }
    });
  }
}
